import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useEffect } from 'react';
import { z } from 'zod';
import { HStack, Spacer } from '@/components/Layout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { FleetMainType } from '../-api';
import { FleetForm } from './-components/FleetForm';
import { InnerNavigation } from './-components/InnerNavigation';
import { ProgressCard } from './-components/ProgressCard';
import { useAddFleetFormStore } from './-store/add-fleet-form-store';
const searchSchema = z.object({
  mainType: z.nativeEnum(FleetMainType).optional()
});
export const Route = createFileRoute('/_staff/fleets/add/')({
  component: FleetAdd,
  validateSearch: zodValidator(searchSchema)
});
function FleetAdd() {
  const {
    mainType
  } = Route.useSearch();
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.fleets.add'
  });
  useDocumentTitle(t('pageTitle'));
  const reset = useAddFleetFormStore(state => state.reset);
  const setMainType = useAddFleetFormStore(state => state.setMainType);
  useEffect(() => {
    // mainTypeがURLパラメータで渡された場合、storeに設定
    if (mainType) {
      setMainType(mainType);
    }
  }, [mainType, setMainType]);
  useEffect(() => {
    // コンポーネントのアンマウント時にフォームデータをリセット
    return () => {
      reset();
    };
  }, [reset]);
  return <HStack className="w-full p-6">
      <InnerNavigation />
      <Spacer variant="m" />
      <FleetForm className="grow min-w-[340px]" />
      <Spacer variant="m" />
      <ProgressCard />
    </HStack>;
}